export default "__VITE_ASSET__GIFtr7up__"